module.exports = __webpack_public_path__ + "static/img/djrm-02.dab007f6.jpg";